export const slugify = (input: string) => {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const sanitizeUrl = (input: string) => {
  while (input.includes('//')) {
    input = input.replace('//', '/');
  }
  return input;
};
